// extracted by mini-css-extract-plugin
module.exports = {"upload-wrap":"upload_upload-wrap__0pDit","ant-upload-text":"upload_ant-upload-text__h46QL"};